/* 
    this object denotes lang codes that need to be translated from
    the usual QS lang code to PT's expected lang code
    https://confluence.playtech.corp/pages/viewpage.action?spaceKey=NL&title=QuickSpin+Direct+Wallet+integration
*/

const qsLangToLiveLang = {
    //'ar': 'ar', Not sure how and if we should handle arabic
    //'bg': 'bg', Not sure how and if we should handle bulgarian
    //'ch': 'ch', Not sure how and if we should handle armenian
    //'es': 'es-mx', Not sure how and if we should handle mexican spanish
    //'es': 'es-pa', Not sure how and if we should handle panamanian spanish
    //'hi': 'hi', Not sure how and if we should handle hindi
    //'hy': 'hy', Not sure how and if we should handle armenian
    'nt': 'no',
    'p1': 'pl',
    //'sk': 'sk', Not sure how and if we should handle slovak
    'zh': 'zh-cn'
}

const temporaryGameIdMethod = function(rlxlauncher) {
    if(rlxlauncher.gameid == 'bbwl') {
        return 'bigbadwolflive';
    }
    return rlxlauncher.gameid;
}

export function game(rlxlauncher) {
    try {
        const currentLocation = new URL(window.location.href);
        const channel = rlxlauncher.getData.channel || 'web';

        const channelToPath = {
            'mobile': 'mcasino',
            'web': 'casino'
        } //TODO: Do we really need this? Should we host these games only from casino?

        //const gameid = rlxlauncher.gameid;
        const gameid = temporaryGameIdMethod(rlxlauncher); //just because this is up in the air right now in early 2024
        let targetLocation = new URL(`${channelToPath[channel]}/games/${gameid}/`, currentLocation.origin);

        const clientid = rlxlauncher.getData.clientid || "";
        targetLocation.searchParams.set('clientid', clientid);

        if (rlxlauncher.getData.partnerid) {
            targetLocation.searchParams.set('partnerid', rlxlauncher.getData.partnerid);
        }

        if (rlxlauncher.getData.lang) {
            const lang = qsLangToLiveLang[rlxlauncher.getData.lang] || rlxlauncher.getData.lang;
            targetLocation.searchParams.set('lang', lang);
        }

        if (rlxlauncher.getData.homeurl) {
            let decodedHomeurl = decodeURIComponent(rlxlauncher.getData.homeurl);
            if (decodedHomeurl.startsWith('action:')) {
                decodedHomeurl = decodedHomeurl.substring('action:'.length)
            }
            try {
                if (!decodedHomeurl.startsWith('https://')) {
                    decodedHomeurl = `https://${decodedHomeurl}`;
                }

                const finalUrl = encodeURIComponent(new URL(decodedHomeurl).href);
                targetLocation.searchParams.set('homeurl', finalUrl);
            } catch (error) {
                console.error('homeurl: ' + error.toString())
            }
        }

        if (rlxlauncher.getData.remoteusername) {
            targetLocation.searchParams.set('remoteusername', rlxlauncher.getData.remoteusername);
        }

        if (rlxlauncher.getData.jurisdiction) {
            targetLocation.searchParams.set('jurisdiction', rlxlauncher.getData.jurisdiction);
        }

        if (rlxlauncher.getData.ticket) {
            targetLocation.searchParams.set('ticket', rlxlauncher.getData.ticket);
        }

        if (rlxlauncher.getData.cashierurl) {
            let decodedCashierUrl = decodeURIComponent(rlxlauncher.getData.cashierurl);
            if (decodedCashierUrl.startsWith('action:')) {
                decodedCashierUrl = decodedCashierUrl.substring('action:'.length)
            }
            try {
                if (!decodedCashierUrl.startsWith('https://')) {
                    decodedCashierUrl = `https://${decodedCashierUrl}`;
                }

                const finalUrl = encodeURIComponent(new URL(decodedCashierUrl).href);
                targetLocation.searchParams.set('cashierurl', finalUrl);
            } catch (error) {
                console.error('cashierurl: ' + error.toString())
            }
        }

        const target = targetLocation.href;
        return target;
    } catch (error) {
        throw new Error('Error :' + error);
    }
}